import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider,
} from "@mui/material"
import { CrudProvider } from "@/context/crudContext"
import { CustomTable } from "@/components/Tables/CustomTable"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { columns } from "@/pages/stock-adjustment/ProductColumns"
import Grid from "@mui/material/Grid2"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import RecentOrders from "@/components/Orders/RecentOrders"
import OrderSummary from "@/components/Orders/OrderSummary"
import BillingDetails from "@/components/Products/BillingDetails"
import { DetailTable } from "@/components/Tables/DetailTable"
const OrderDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["stock-adjustment", id], `stock-adjustments/${id}`)

  if (isLoading) {
    return <div>Loading...</div>
  }

  const adjustment = response?.data

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5 className="text-lg font-semibold">Stock Adjustment Details</h5>
        <ul className="breadcrumb text-sm">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i> Dashboard
            </Link>
          </li>
          <li>
            <Link to="/customers">Orders</Link>
          </li>
          <li>{adjustment.code}</li>
        </ul>
      </div>

      {/* Responsive Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-4 xxl:grid-cols-5 gap-6">
        {/* Product Table Section */}
        <div className="card bg-white border-0 px-4 py-4 rounded-3 mb-4 lg:col-span-3 xxl:col-span-4">
          <p className="mb-5 text-base font-semibold text-black">Products</p>
          <CrudProvider>
            <ProductList adjustment={adjustment} isLoading={isLoading} />
          </CrudProvider>
        </div>

        {/* Detail Info Section */}
        <div className="card bg-white border-0 p-4 rounded-3 mb-4">
          <div className="space-y-4">
            <DetailItem label="Code" value={adjustment.code} />
            <DetailItem label="Reference" value={adjustment.reference} />
            <DetailItem label="Date" value={adjustment.date} />
            <div>
              <p className="text-sm text-gray-600">Adjusted By:</p>
              <div className="mt-1">
                <LetterAvatar
                  name={adjustment.createdBy.name}
                  subtitle={adjustment.createdBy.email}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function ProductList({ adjustment, isLoading }) {
  return (
    <DetailTable
      label="Orders"
      columns={columns}
      data={adjustment.products}
      isLoading={isLoading}
    />
  )
}

function DetailItem({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-600">{label}:</p>
      <span className="block font-medium text-black mt-1 text-sm break-all">
        {value}
      </span>
    </div>
  )
}

export default OrderDetails
